module.exports = __webpack_public_path__ + "media/images/coupon/warning-3bb0621b35d8ebfb6f1cfd593eff8658.png";